import React from "react";
import { Modal, Button } from "react-bootstrap";
import { t } from "../../i18n";

interface Props {
    show: boolean;
    originalAmount: number;
    originalCurrency: string;
    euroAmount: number;
    onConfirm: () => void;
    onCancel: () => void;
}

export const LargeAmountConfirmationDialog: React.FC<Props> = ({
    show,
    originalAmount,
    originalCurrency,
    euroAmount,
    onConfirm,
    onCancel
}) => {
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 8,
    });

    const euroFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
    });

    return (
        <Modal show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>{t("dialog.largeAmount.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-warning">
                    <p>
                        <strong>{t("dialog.largeAmount.message")}</strong>
                    </p>
                    <p>
                        <strong>Amount:</strong> {formatter.format(originalAmount)} {originalCurrency}
                    </p>
                    {originalCurrency !== "EUR" && (
                        <p>
                            <strong>EUR Equivalent:</strong> {euroFormatter.format(euroAmount)}
                        </p>
                    )}
                    <p className="mb-0">
                        {t("dialog.largeAmount.confirm")}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {t("button.cancel", undefined, "Cancel")}
                </Button>
                <Button variant="primary" onClick={onConfirm}>
                    {t("button.confirm", undefined, "Confirm")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

